/**
 * Tracking constants for the Astra chat surfaces.
 *
 * Uses INTERACTION_TYPES from shared/observability for the event `type`.
 */

/** Page identifiers for the two chat surfaces. */
export const ASTRA_PAGES = {
  /** Mobile: the full-screen `/chat` route. */
  chat: 'astra-chat',
  /** Desktop: the floating panel over the Cloudscape shell. */
  desktopPanel: 'astra-desktop',
} as const;

export type AstraPage = (typeof ASTRA_PAGES)[keyof typeof ASTRA_PAGES];

/** Action names used in `type: 'action_triggered'` events. */
export const ASTRA_ACTIONS = {
  sendMessage: 'send_message',
  /** A starter chip was picked — split from a typed send so chip uptake is measurable. */
  pickSuggestedPrompt: 'pick_suggested_prompt',
  stopResponse: 'stop_response',
  newConversation: 'new_conversation',
  close: 'close',
  /** Desktop only: toggled the floating panel between its normal and maximized sizes. */
  toggleExpand: 'toggle_expand',
  /** The user opened the chat from the nav help menu. */
  openFromNav: 'open_from_nav',
} as const;

/** One of the action names in `ASTRA_ACTIONS`. */
export type AstraAction = (typeof ASTRA_ACTIONS)[keyof typeof ASTRA_ACTIONS];
